import { Injectable } from '@angular/core';
import { HeadersService } from './headers.service';
import { HttpClient } from '@angular/common/http';
import { Organisation } from '../models/organisation';
import { UserData } from '../models/identity/user-data';
import { forkJoin, map, Observable, ReplaySubject, catchError, of } from 'rxjs';
import { SecurityService } from './security.service';

@Injectable()
export class OrganisationService {
    private _currentLandlords: Organisation[];
    public landlordChanged = new ReplaySubject<Organisation>(1);
    public restrictedOrgTypes = ['local authority', 'almo', ''];

    constructor(private headersService: HeadersService, private httpClient: HttpClient,
        private securityService: SecurityService) {
    }

    public getUsersOrganisations(userData: UserData): Observable<void> {
        const headers = this.headersService.getHeaders();
        const url = '/api/Organisations';

        return this.httpClient.get<Organisation[]>(url, { headers: headers }).pipe(
            map((organisations: Organisation[]) => {
                this.processOrganisationsAndUserData(organisations, userData);
            })
        );
    }

    private processOrganisationsAndUserData(organisations: Organisation[], userData: UserData): void {
        this._currentLandlords = organisations;

        if (!this._currentLandlords || this._currentLandlords.length === 0) {
            return;
        }

        if (!userData || !userData.organizationId) {
            return;
        }

        this._currentLandlords.sort((left: Organisation, right: Organisation) => {
            if (left.name < right.name) return -1;
            else if (left.name > right.name) return 1;
            return 0;
        });

        const foundLandlord = this._currentLandlords.find(org => org.id === userData.organizationId);
        
        if (foundLandlord) {
            foundLandlord.isCurrentChoice = true;
            this.landlordChanged.next(foundLandlord);
        } else {
            if (this._currentLandlords.length > 0) {
                this._currentLandlords[0].isCurrentChoice = true;
                this.landlordChanged.next(this._currentLandlords[0]);
            }
        }
    }

    get currentLandlords(): Organisation[] {
        return this._currentLandlords;
    }

    get currentLandlord(): Organisation | undefined {
        return this._currentLandlords?.find(cl => cl.isCurrentChoice);
    }

    changeLandlordSelection(newWKey: number, oldWKey: number): void {
        const selectedLandlord = this._currentLandlords.find(cl => cl.wKey === newWKey);
        const oldLandlord = this._currentLandlords.find(cl => cl.wKey === oldWKey);

        if(!selectedLandlord || !oldLandlord) return;

        selectedLandlord.isCurrentChoice = true;

        oldLandlord.isCurrentChoice = false;

        this.landlordChanged.next(selectedLandlord);
    }
}
